<script lang="ts">
	import { SubscriptionMenu } from "@entitlements/client"
	import { LoadingSpinner } from "misc-ui"
	import { getSubscriptionManager } from "../../../../modules/subscription-management/SubscriptionManager.svelte"
	import LuxPlayIcon from "../../../reusable/icons/LuxPlayIcon.svelte"
	import { LUX_PLAY_SUBSCRIPTION_LINK } from "../../../../modules/subscription-management/subscriptionLinks"

	let subscriptionManager = getSubscriptionManager()
	let loadingPromise = $derived(subscriptionManager.loadingPromise)
	let luxPlaySubscription = $derived(
		subscriptionManager.subscriptions.find((sub) => sub.type === "LUX_PLAY_ANNUAL"),
	)

	function onSubscribeClick() {
		window.open(LUX_PLAY_SUBSCRIPTION_LINK, "_blank")
	}
</script>

<div class="subscription-container">
	{#await loadingPromise}
		<LoadingSpinner height="6rem" color="var(--color-main)" />
	{:then}
		<SubscriptionMenu
			title="LuxPlay Subscription"
			description="LuxPlay turns your own projector into a powerful creative tool, using our proprietary software and AI to let you map, schedule, and design your own immersive shows."
			unitType="unused devices"
			subscriptionCopy={[
				"Subscribe to unlock limitless creativity and bring your ideas to life on any surface.",
			]}
			onSubscribe={() => onSubscribeClick()}
			activeSubscription={luxPlaySubscription}
		>
			{#snippet heading()}
				<div class="heading-icon">
					<LuxPlayIcon strokeColor="var(--color-text-light)" />
				</div>
			{/snippet}
		</SubscriptionMenu>
	{/await}
</div>

<style>
	.heading-icon {
		margin-top: 0.2rem;
		height: 2.5rem;
		width: fit-content;
	}
</style>
